<div [ngClass]="{ 'fcp-radio-flex': position === 'row' }">
    <div class="fcp-radio" *ngFor="let option of options">
        <label class="fcp-radio-label">
            <input
                type="radio"
                class="fcp-radio-input"
                [value]="option.value"
                [checked]="option.value === value"
                [disabled]="option.disabled"
                (change)="updateValue(option)"
            />
            <span>{{ option.label }}</span>
            <p class="fcp-radio-description" *ngIf="option.description">{{ option.description }}</p>
        </label>
    </div>
</div>
